import React from 'react';
import styled from 'styled-components';
import NoticeContainer from '../view/notice/container/NoticeContainer';

const Notice = () => {
  return (
    <Container>
      <NoticeContainer />
    </Container>
  );
};

const Container = styled.div``;

export default Notice;
